// extracted by mini-css-extract-plugin
module.exports = {"container":"container-module--container--1Qzhq","primary":"container-module--primary--1v0LL","secondary":"container-module--secondary--IhCt1"};